import { LabeledToggle } from '../../../../../../common/MUI';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  toggleContainer: {
    padding: '3px 8px'
  }
});

const ToggleAnchorPoints = ({ classes, isEnabled, toggleAnchorPoints, eventHub, ...other }) => {
  const handleToggle = () => {
    toggleAnchorPoints(!isEnabled);
  };

  return (
    <LabeledToggle
      checked={isEnabled}
      onChange={handleToggle}
      classes={{
        container: classes.toggleContainer
      }}
      label={`${isEnabled ? 'Hide' : 'Show'} Anchor Points`}
      menuTooltipText="Enable/Disable Anchor Points"
      {...other}
    />
  );
};

export default withStyles(styles)(ToggleAnchorPoints);
